module.exports = __webpack_public_path__ + "img/denizbank.f814b604.svg";